import React, { useContext, useEffect } from 'react'
import { DI, DIProps } from '../../../../Core';
import { StepType, useTour } from '../../../Other/tour';
import { BlockStack, Box, Button, InlineStack, Link, Text } from '@shopify/polaris';
import { UserContext } from '../../../../Actions/NecessaryFun';
import { t } from 'i18next';

const BulUploadTourListing = (props: DIProps) => {
    const context = useContext<any>(UserContext);
    const { setIsOpen, setCurrentStep, setSteps, isOpen } = useTour();

    const endTour = () => {
        props.di.POST('connector/config/saveConfig', {
            data: [
                {
                    data: JSON.parse(
                        JSON.stringify(
                            {
                                bulk_upload_tour: {
                                    parts_visited: 5,
                                },
                            }
                        )
                    ),
                    group_code: 'tour',
                },
            ],
        }).then((response: any) => {
            setIsOpen(false);
            props.di.globalState.removeLocalStorage('start_tour');
            if (response.success)
                return;
            props.error(
                t('Failed to end tour')
            );
        });
    }

    const getTourData = () => {
        props.di.POST("connector/config/getConfig", {
            group_code: ["tour"],
        }).then((response: any) => {
            if (response.success) {
                let value = response.data.find((a: any) => a.group_code === 'tour')?.value
                if (value?.bulk_upload_tour) {
                    const parts_visited = value?.bulk_upload_tour?.parts_visited ?? 0
                    if (parts_visited === 4) {
                        setIsOpen(true);
                        setCurrentStep(0);
                        setSteps?.(steps)
                    } else {
                        setIsOpen(false);
                        setCurrentStep(0);
                        setSteps?.([]);
                        props?.di.globalState.removeLocalStorage('start_tour');
                    }
                }
            }
        })
    }

    const steps: StepType[] = [
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Listing Section")}</Text>
                        <Text as="p">
                            {t("This is where all your products are displayed.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '',
            OnClose: () => { endTour() },
            position: 'left',
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Apply a filter")}</Text>
                        <Text as="p">
                            {t("To choose the products you want to upload, look for them by clicking on")} <Text as='strong'>{t("More filters")}</Text>.
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.bulktour_listing_filter',
            stepInteraction: true,
            hideActions: {
                next: true,
                back: true
            },
            position: 'left',
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Filter by Template")}</Text>
                        <Text as="p">
                            {t("Filter the assigned products by selecting the name of the template from the drop-down menu.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            position: 'left',
            selector: '#bulktour_listing_template',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                let templateName = JSON.parse(props?.di?.globalState?.get('filters') ?? '{}')?.['Template name']?.textValue;
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' variant='primary'
                                    onClick={() => { p?.nextClick() }}
                                    disabled={!templateName}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div >
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Filter by Template")}</Text>
                        <Text as="p">
                            {t("Click on")} <Text as='strong'>{t("Done")}</Text>.
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            position: 'left',
            selector: '#filter_sheet_done',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                let disabled = true;
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary'
                                    onClick={() => { p?.nextClick() }}
                                    disabled={disabled}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div >
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Select Products")}</Text>
                        <Text as="p">
                            {t("Check the box above to select all the products that are assigned in the chosen template.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '.ant-table-selection:has(input[aria-label="Select all"])',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { setCurrentStep(1) }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Select Actions")}</Text>
                        <Text as="p">
                            {t("Once the products have been assigned, you can proceed to upload them on Amazon. Click on")} <Text as='strong'>{t("Select actions")}</Text> {t("to initiate the process.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '#popoverActivator',
            stepInteraction: true,
            OnClose: () => { endTour() },
            hideActions: {
                next: true,
                back: true
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Initiate Product Upload")}</Text>
                        <Text as="p">
                            {t("To start uploading your selected products on Amazon, simply click on the")} <Text as='strong'>{t("Upload Product(s)")}</Text> {t("button.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            selector: '#amazonUpload',
            stepInteraction: true,
            OnClose: () => { endTour() },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backAction() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' disabled onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            }
        },
        {
            selector: '#upload_tour.Polaris-Button.Polaris-Button--variantPrimary',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("Click on")} <Text as='span' fontWeight='semibold'>{t("Confirm")}</Text> {t("to initiate product upload.")}
                        </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                next: true,
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Upload")}</Text>
                        <Text as="p">
                            {t("Congratulations! The product upload tour is over. To see the status of each product, check the activity column in the listing grid.")}
                        </Text>
                        <Text as="p">
                            {t("Please reach out to us")} <Link onClick={() => {
                                endTour()
                                props.history('../../panel/user/support')
                            }}>{t("here")}</Link> {t("if you have any further questions.")}
                        </Text>
                        <Text as='p' fontWeight='semibold'>{t("Click on “Finish” to End Tour.")} </Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='end'>
                            {/* <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button> */}
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { endTour() }}>Finsih</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        {
            selector: '',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Product Listing")}</Text>
                        <Text as="p">
                            {t("The template you selected either has no products assigned to it, or products are still being assigned to it. Please check the progress in the Template Grid under")} <Text as='strong'>{t("Settings &gt; Templates")}</Text>.
                        </Text>
                        <Text as="p">{t("Please choose a different template for upload.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true
            },
            stepInteraction: true,
            OnClose() {
                endTour();
            },
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { setCurrentStep(2) }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }

    ]

    useEffect(() => {
        if (props?.di.globalState.get('start_tour') === 'bulk_upload_2' && window.innerWidth > 750) {
            getTourData();
        } else {
            setIsOpen(false);
            setCurrentStep(0);
            setSteps?.([])
        }
    }, [])

    useEffect(() => {
        if (props?.di.globalState.get('start_tour') === 'bulk_upload_2' && window.innerWidth > 750 && isOpen) {
            setSteps?.(steps);
        }
    }, [props?.di?.globalState?.get('filters')])

    return null;
}

export default DI(BulUploadTourListing);